import React, { useEffect, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { CheckRounded } from "@mui/icons-material";
import { Amplify } from "aws-amplify";
import { fetchUserAttributes, getCurrentUser } from "aws-amplify/auth";
import { USER_AUTH_CONFIG } from "../config/aws-config";
import { UserAuthCard, UserAuthShell } from "./user-auth-layout";

const AuthGranted = () => {
  const [userEmail, setUserEmail] = useState("");

  useEffect(() => {
    const loadCurrentUser = async () => {
      try {
        Amplify.configure(USER_AUTH_CONFIG);
        await getCurrentUser();
        const attributes = await fetchUserAttributes();
        setUserEmail(attributes.email || "");
      } catch (error) {
        console.error("Error fetching user:", error);
        setUserEmail("");
      }
    };

    loadCurrentUser();
  }, []);

  return (
    <UserAuthShell maxWidth={460}>
      <UserAuthCard contentSx={{ p: { xs: 3.5, sm: 5 } }}>
        <Stack spacing={2.25} alignItems="center" textAlign="center">
          <Box
            sx={{
              width: 72,
              height: 72,
              display: "grid",
              placeItems: "center",
              borderRadius: "50%",
              color: "#2f7d5b",
              bgcolor: "#e5f6ee",
              border: "1px solid #c9eadb",
            }}
          >
            <CheckRounded sx={{ fontSize: 40 }} />
          </Box>

          <Box>
            <Typography
              component="h1"
              sx={{
                color: "#253940",
                fontSize: { xs: 28, sm: 32 },
                fontWeight: 700,
                letterSpacing: "-0.035em",
              }}
            >
              You&apos;re signed in
            </Typography>
            <Typography sx={{ mt: 1, color: "#71838b", lineHeight: 1.65 }}>
              Authentication is complete. You can safely close this window.
            </Typography>
          </Box>

          {userEmail && (
            <Box
              sx={{
                width: "100%",
                px: 2,
                py: 1.5,
                borderRadius: 3,
                bgcolor: "#f4f9fa",
                border: "1px solid #e1ecef",
              }}
            >
              <Typography sx={{ color: "#71838b", fontSize: 12 }}>
                Signed in as
              </Typography>
              <Typography
                sx={{
                  mt: 0.25,
                  color: "#3f5963",
                  fontWeight: 650,
                  overflowWrap: "anywhere",
                }}
              >
                {userEmail}
              </Typography>
            </Box>
          )}
        </Stack>
      </UserAuthCard>
    </UserAuthShell>
  );
};

export default AuthGranted;
